import { SearchIcon } from '../icons'
import { useAutoFocus } from '../../hooks/useAutoFocus'

// The one search box (Recipes, Add a meal, All items): magnifier, field, a
// 2 px ink ring while typing. `label` is its placeholder and accessible name.
export function SearchField({ label, value, onChange, autoFocus = false, className }: {
  label: string
  value: string
  onChange: (value: string) => void
  autoFocus?: boolean
  className?: string
}) {
  const focusRef = useAutoFocus<HTMLInputElement>(autoFocus)
  return (
    <div className={className ? `ml-search ${className}` : 'ml-search'}>
      <SearchIcon size={20} />
      <input ref={focusRef} type="search" className="ml-search__input" value={value} placeholder={label} aria-label={label}
        autoComplete="off" enterKeyHint="search" onChange={e => onChange(e.target.value)} />
    </div>
  )
}
